<template>
  <div
    id="link-right"
    :class="beyond?'beyond':''"
  >
    <!-- 链接信息 -->
    <div
      ref="attrWrapper"
      class="attr-wrapper"
    >
      <div class="attr-title">
        {{ $t('详情') }}
      </div>
      <div class="attr-content">
        <div class="content-key">
          {{ $t('大小') }}:
        </div>
        <div class="content-val">
          {{ curData.size }}
        </div>
        <div class="content-key">
          {{ $t('创建者') }}:
        </div>
        <co-tips
          :content="curData.delivery_creator"
          position="bottom"
        >
          <div class="content-val ellipsis">
            {{ curData.delivery_creator }}
          </div>
        </co-tips>
        <div class="content-key">
          {{ $t('更新时间') }}:
        </div>
        <div class="content-val">
          {{ curData.delivery_update }}
        </div>
        <div class="content-key">
          {{ $t('创建时间') }}:
        </div>
        <div class="content-val">
          {{ curData.delivery_mtime }}
        </div>
        <div class="content-key" v-if="secretSwitch">
          {{ $t('文件密级') }}
        </div>
        <div class="content-val" v-if="secretSwitch">
          {{ curData.fileSecret }}
        </div>
        <div class="content-key">
          {{ $t('路径') }}:
        </div>
        <div class="content-val">
          {{ curData.path }}
        </div>
        <div class="content-key">
          {{ $t('备注') }}:
        </div>
        <div class="content-val">
          {{ curData.note }}
        </div>
      </div>
    </div>
    <!-- 版权 -->
    <div class="copyright">
      <span
        :style="{color:copyrightColor}"
        v-text="copyright"
      />
    </div>
  </div>
</template>
<script>
import { formatDate, resolvePath, typeIcon } from 'js/util/util.js'
import coTips from 'components/common/tips/index.vue'
import _$ from 'js/api/getdata'

export default {
  components: {
    coTips,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
        }
      },
    },
  },
  data() {
    return {
      copyright: '©Filez', // 版权文字
      copyrightColor: '#929CA9', // 版权文字颜色
      beyond: false,
      secretSwitch: false, // 密级开关
    }
  },
  computed: {
    curData() {
      return {
        name: resolvePath(this.data.path).name,
        size: !this.data.size ? '--' : this.data.size,
        delivery_creator: this.data.delivery_creator,
        delivery_update: formatDate(this.data.modified, 'yyyy-MM-dd hh:mm'),
        delivery_mtime: formatDate(this.data.delivery_mtime, 'yyyy-MM-dd hh:mm'),
        path: this.data.path,
        fileType: `#${typeIcon(resolvePath(this.data.path).type)}`,
        note: this.data.desc,
        fileSecret: this.data.security_file_name,
      }
    },
  },
  watch: {
    curData: {
      handler(n) {
        const vm = this
        this.$nextTick(() => {
          vm.checkBeyondWinH()
        })
        window.addEventListener('resize', vm.checkBeyondWinH)
      },
      deep: true,
    },
  },
  mounted() {
    this.getSecretSwitch()
  },
  methods: {
    /**
         * 检查wrapper的高度是否超出body
         */
    checkBeyondWinH() {
      const vm = this
      const HH = 50 // header height
      if (!vm.$refs.attrWrapper) return
      if (vm.$refs.attrWrapper.offsetHeight > (document.body.clientHeight - HH)) {
        vm.beyond = true
      } else {
        vm.beyond = false
      }
    },
    getSecretSwitch() {
      _$.getData('getSecretSwitch').then((res) => {
        this.secretSwitch = res.data.security_classification_switch === '1'
      })
    },
  },

}
</script>
<style lang="less" scoped>

#link-right{
  height: 100%;
  box-sizing: border-box;
  width: 288px;
  position: relative;
  border-left: 1px solid #e2e6ec;
  .attr-wrapper{
    padding: 32px 24px 0 24px;
    position: relative;
    overflow-y: auto;
    box-sizing: border-box;
    height: auto;
  }
}
.ellipsis{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.attr-img{
  width: 22px;
  height: 22px;
  vertical-align: -5px;
  margin-right: 6px;
  position: relative;
  left: -1px;
}
.attr-title{
  display: inline-block;
  height: 22px;
  line-height: 22px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #282E3D;
}
//文件信息
.attr-content{
  margin-top: 20px;
  .content-key{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #67707C;
    line-height: 20px;
    margin-bottom: 4px;
  }
  .content-val{
    display: inline-block;
    max-width: 240px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #1B2733;
    line-height: 20px;
    margin-bottom: 20px;
    box-sizing: border-box;
    word-break: break-all;
  }
}
//版权
.copyright{
  position: absolute;
  width: 83px;
  text-align: center;
  left: 0;
  right: 0;
  bottom: 18px;
  margin: 0 auto;
  font-size: 12px;
}
.beyond{
  overflow: auto;
  .copyright{
    position: static;
    margin-bottom: 18px;
  }
}
</style>
